/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import {
	ContentComponentContextProvider,
	type ContentComponentProps,
} from '../../hooks/useContentComponentContext';
import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapper';

import { ContentComponent } from './ContentComponent';

export const ContentComponentWrapper = (props: ContentComponentProps) => {
	return (
		<GlobalWrapper>
			<ContentComponentContextProvider value={{ ...props }}>
				<ContentComponent />
			</ContentComponentContextProvider>
		</GlobalWrapper>
	);
};
